
export default {
  influencerTitle: "تواصل مع أهم المؤثرين",
  influencerSubtitle: "عزز علامتك التجارية بتسويق المؤثرين",
  influencerDescription: "شارك مع المؤثرين الرائدين لتضخيم رسالتك والوصول إلى جماهير جديدة",
  browseCameos: "تصفح مقاطع الفيديو الشخصية",
  influencerStats: "إحصائيات المؤثر",
  influencerReach: "وصول المؤثر",
  averageEngagement: "متوسط ​​التفاعل",
  successfulCampaigns: "حملات ناجحة",
  bookInfluencer: "حجز مؤثر",
  viewInfluencers: "عرض جميع المؤثرين",
  
  cameosTitle: "مقاطع فيديو شخصية من المؤثرين المفضلين لديك",
  cameosDescription: "احجز مقاطع فيديو مخصصة لعلامتك التجارية أو استخدامك الشخصي",
  personalizedVideos: "مقاطع فيديو مخصصة",
  forBrands: "للعلامات التجارية",
  categories: "الفئات",
  featured: "مميز",
  trending: "رائج",
  all: "الكل",
  search: "بحث",
  searchPlaceholder: "البحث عن المؤثرين",
  priceRange: "نطاق السعر",
  responseTime: "وقت الاستجابة",
  bookNow: "احجز الآن",
  viewProfile: "عرض الملف الشخصي",
  
  bookInfluencerTitle: "احجز حملة المؤثر الخاصة بك",
  bookInfluencerDesc: "أنشئ حملات مؤثرة مع أفضل المؤثرين لدينا",
  searchInfluencers: "البحث عن المؤثرين",
  customBooking: "حجز مخصص",
  customBookingDesc: "إنشاء حملة مؤثر مخصصة",
  view: "عرض",
  book: "حجز",
  
  backToInfluencers: "العودة إلى المؤثرين",
  perCampaign: "لكل حملة",
  followers: "متابعين",
  expertise: "خبرة",
  aboutInfluencer: "نبذة عن المؤثر",
  contactDetails: "تفاصيل الاتصال",
  socialProfiles: "الملفات الاجتماعية",
  pricingInformation: "معلومات التسعير",
  standardCampaign: "حملة قياسية",
  extendedCampaign: "حملة ممتدة",
  personalizedVideo: "فيديو مخصص",
  whatYouGet: "ما تحصل عليه",
  contentCreation: "إنشاء المحتوى",
  socialMediaPosts: "منشورات وسائل التواصل الاجتماعي",
  engagementWithAudience: "التفاعل مع الجمهور",
  performanceReport: "تقرير الأداء",
  contactInformation: "معلومات الاتصال",
  getInTouch: "تواصل معنا",
  bookingInstructions: "تعليمات الحجز",
  scheduleCall: "جدولة مكالمة",
  similarInfluencers: "مؤثرون مشابهون",
  noSimilarInfluencers: "لم يتم العثور على مؤثرين مشابهين",
  comingSoon: "قريبًا",
  
  // Influencer Sign Up
  becomeInfluencer: "انضم كمؤثر",
  joinAsInfluencer: "انضم كمؤثر",
  influencerSignUpDesc: "أكمل ملفك الشخصي للانضمام إلى منصتنا والتواصل مع العلامات التجارية",
  basicInfo: "المعلومات الأساسية",
  yourName: "اسمك",
  categoryLabel: "الفئة",
  selectCategory: "اختر الفئة",
  aboutYou: "نبذة عنك",
  followersCount: "عدد المتابعين",
  campaignPrice: "سعر الحملة (ريال)",
  profileImageUrl: "رابط صورة الملف الشخصي",
  areasOfExpertise: "مجالات الخبرة",
  socialMediaLinks: "روابط التواصل الاجتماعي",
  contactInfo: "معلومات الاتصال",
  submitApplication: "تقديم الطلب",
  applicationSubmitted: "تم التقديم بنجاح!",
  applicationUnderReview: "سيتم مراجعة طلبك وسنتواصل معك قريباً",
  alreadyHaveProfile: "لديك ملف شخصي بالفعل",
  status: "الحالة",
  approved: "موافق عليه",
  pending: "قيد المراجعة",
  rejected: "مرفوض",
  rejectionReason: "سبب الرفض",
  
  // Admin Approval
  influencerApproval: "موافقة المؤثرين",
  pendingApprovals: "في انتظار الموافقة",
  approvedInfluencers: "المؤثرون الموافق عليهم",
  rejectedInfluencers: "المؤثرون المرفوضون",
  approve: "موافقة",
  reject: "رفض",
  confirmRejection: "تأكيد الرفض",
  rejectInfluencer: "رفض المؤثر",
  rejectionReasonOptional: "سبب الرفض (اختياري)",
} as const;
